import { ICellRendererParams } from 'ag-grid-enterprise'
import { ChevronRightIcon } from 'lucide-react'

import type { ControlRow } from '@/pages/control/ag-grid-control/types'

export const ControlTitleGroupCell = ({ data }: ICellRendererParams<ControlRow>) => {
  if (!data) return null

  const { categoryName, isExpanded } = data

  return (
    <div className='flex size-full items-center gap-1.5 pr-4'>
      <div className='text-main-foreground-primary'>
        <ChevronRightIcon
          className={`size-4 transition-transform duration-200 ${isExpanded ? 'rotate-90' : ''}`}
        />
      </div>
      <span className='font-medium text-main-foreground-primary text-body-default'>
        {categoryName}
      </span>
    </div>
  )
}
